import { put, call } from 'redux-saga/effects';
import endpoint from "../../const/backend";
const axios = require('axios');

function apiAdd(body){
    return body.addClient({
        variables:{ 
            name: body.client.name,
            document: body.client.document,
            branch: body.client.branch,
            email: body.client.email,
            phone: body.client.phone,
            celphone: body.client.celphone
        }
    })
}
  
export function* addClient(action){
    try{
        const response = yield call(apiAdd, action.body);
        yield put({ type: "SUCCESS_ADD_CLIENT", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_ADD_CLIENT" })
    }
}

function apiUpdate(body){
    return body.updateClient({
        variables:{ 
            _id: body.client._id, 
            name: body.client.name,
            document: body.client.document,
            branch: body.client.branch,
            email: body.client.email,
            phone: body.client.phone,
            celphone: body.client.celphone
        }
    });
}

export function* updateClient(action){
    try{
        const response = yield call(apiUpdate, action.body);
        yield put({ type: "SUCCESS_UPDATE_CLIENT", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_UPDATE_CLIENT" })
    }
}

function apiRemove(body){
    return body.removeClient({
        variables:{ 
            _id: body._id
        }
    });
}

export function* removeClient(action){
    try{
        const response = yield call(apiRemove, action.body);
        yield put({ type: "SUCCESS_REMOVE_CLIENT", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_REMOVE_CLIENT" })
    }
}

function apiClients(body){
    return axios.post(endpoint+"/clients", body , 
        { headers: { 'Content-Type': 'application/json'}
    });
}
  
export function* getClients(action){
    try{
        const response = yield call(apiClients, action.body);
        yield put({ type: "SUCCESS_GET_CLIENTS", payload: { data: response } });
    }catch(err){
        yield put({ type: "FAILURE_GET_CLIENTS" })
    }
}


// WEBPACK FOOTER //
// ./src/store/sagas/client.js